<input
  #fileInput
  (change)="onFileInputChange(fileInput.files)"
  class="hidden-input"
  type="file"
  accept="image/*,.pdf" />

<button
  [attr.aria-label]="'aria_label/file-upload' | translate"
  (click)="fileInput.click()"
  class="camera custom-camera">
  <span class="icon-file-button"></span>
</button>
